import Criteria from './Criteria'

export default class LocationFields extends Criteria{

}